import { React, useEffect } from "react";
import useIsMobile from "../hooks/useIsMobile";
import abrirWhatsApp from "../hooks/abrirWhatsapp";
import styles from "../styles/naoTenhoContrato.module.css";
import usePageTracking from "../components/pageTracking";
import ReactPixel from "react-facebook-pixel";
import { useNavigate } from "react-router-dom";

const NaoTenhoContrato = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  usePageTracking();

  useEffect(() => {
    ReactPixel.pageView(); // Dispara evento de pageview
    ReactPixel.track("NaoTenhoContrato"); // Evento customizado, opcional
  }, []);
  return (
    <div className="container-fluid tela-central text-center">
      <div className="text-center">
        <div className="logo-topo">
          <img className="mt-1" src="../img/iconwp.png" alt="" width="120px" />
        </div>
        <div className={`${styles.conteudo}`}>
          <div className="">
            <h1 className={`${styles.titulo}`}>Ah, que pena...</h1>
            <br />
            <label className={`${styles.descricao}`}>
              Caso você não tenha o contrato em mãos, é importante que você fale
              com um advogado especialista para entender melhor os seus direitos
              e evitar abusos.
            </label>
            <br />
            <br />
            <button
              className={`btn btn-secondary ${
                isMobile ? "" : "btn-lg me-3"
              } borda-botao`}
              style={{ width: "400px" }}
              onClick={() => navigate("/cadastro")}
            >
              Voltar
            </button>
            <button
              className={`btn btn-primary ${
                isMobile ? "" : "btn-lg me-3"
              } borda-botao`}
              style={{ width: "400px" }}
              onClick={() => abrirWhatsApp(false)}
            >
              Quero falar com um especialista!
            </button>
          </div>
        </div>
      </div>

      {/* Elementos decorativos */}
      <div className="quadrado-preto" />
      <div className="quadrado-listrado" />
      <div className="quadrado-listrado-preto" />
    </div>
  );
};

export default NaoTenhoContrato;
